/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Devices_Disabled_DescInputs */

const vi_irrigation_devices_disabled_desc = /** @type {(inputs: Irrigation_Devices_Disabled_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bật tích hợp và nhập tài khoản API tưới ở màn Cấu hình SmartLab để xem bộ tưới.`)
};

/**

* @param {Irrigation_Devices_Disabled_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_devices_disabled_desc = /** @type {((inputs?: Irrigation_Devices_Disabled_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Devices_Disabled_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_devices_disabled_desc(inputs)
});